import { render, staticRenderFns } from "./whatnowSummary.vue?vue&type=template&id=3ab4c69e&scoped=true"
import script from "./whatnowSummary.vue?vue&type=script&lang=js"
export * from "./whatnowSummary.vue?vue&type=script&lang=js"
import style0 from "./whatnowSummary.vue?vue&type=style&index=0&id=3ab4c69e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab4c69e",
  null
  
)

export default component.exports